module.exports = "/images/us.svg?912cb4a8f30b24032f0dbf258d674ae9";